import {Component, ContentChild, EventEmitter, Input, Output} from "@angular/core";
import {FUIIconComponent} from "../../../../icons/icon/icon.component";

@Component({
    selector: "fui-modal-window-toolbar",
    styleUrls: ["./modal-window-toolbar.component.scss"],
    templateUrl: "./modal-window-toolbar.component.html"
})
export class FUIModalWindowToolbarComponent {
    @Output() public closed: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
    @Input() public title: string;
    @Input() public titleParams: any;

    constructor() {
    }

    public close(): void {
        this.closed.emit(true);
    }
}
